export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5532.ca41bd49.jpg";